@if (storeLink) {
  @if (visible) {
    <div class="wrapper">
      <p>
        {{ 'appvertise_small.text' | translate }}<br />
        <a class="wrapper__link" [href]="storeLink">{{ 'appvertise_small.link' | translate }}</a>
      </p>
      <i class="wrapper__icons material-icons md-36" (click)="closeMe()">close</i>
    </div>
  }
} @else {
  <p class="wrapper">
    <span> {{ 'appvertise_small.desktop' | translate: { screenWidthInPixel: screenWidthInPixel } }} </span>
  </p>
}
<ng-template #desktop>
  <p class="wrapper">
    <span> {{ 'appvertise_small.desktop' | translate: { screenWidthInPixel: screenWidthInPixel } }} </span>
  </p>
</ng-template>
